module.exports = __webpack_public_path__ + "img/banner.93259784.jpg";